import { useRef } from 'react';
import clsx from 'clsx';

import { FloatingPanel } from '@/shared/ui/FloatingPanel';
import { onAltArrowDownOpen } from '../../utils';
import { RChevron, RFolder } from './icons';

/** Привязка задачи из макета: иконка папки, подчёркнутое название привязки и
 *  шеврон. Раскрывается панелью с блоком выбора смарт-процесса/сделки/лида. */
export function RBindingField({
  label,
  open,
  onToggle,
  disabled,
  children,
}: {
  label: string;
  open: boolean;
  onToggle: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  const rowRef = useRef<HTMLSpanElement>(null);

  return (
    <span ref={rowRef} className="relative flex min-w-0 items-center gap-[7px]">
      <RFolder />
      <button
        type="button"
        title="Привязка задачи"
        disabled={disabled}
        onClick={onToggle}
        onKeyDown={onAltArrowDownOpen(open, onToggle)}
        className={clsx(
          'flex min-w-0 max-w-[150px] items-center gap-[6px] min-[620px]:max-w-[240px]',
          'border-b border-[rgba(59,77,127,0.3)] pb-[3px] pt-[2px]',
          'text-[11px] font-bold text-[#141E31] transition-colors min-[620px]:text-[12px]',
          disabled ? 'cursor-not-allowed opacity-50' : 'hover:border-[#57B792]'
        )}
        aria-expanded={open}
      >
        <span className="min-w-0 truncate">{label}</span>
        <RChevron size={11} />
      </button>

      {open ? (
        <FloatingPanel
          anchorRef={rowRef}
          topOffset={32}
          className="max-h-[420px] w-[600px] max-w-[calc(100vw-80px)] overflow-y-auto rounded-[16px] bg-white p-[14px] shadow-[0_20px_46px_rgba(20,30,49,0.24)]"
        >
          {children}
        </FloatingPanel>
      ) : null}
    </span>
  );
}
